exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".amount{display:inline-block;font-family:serif;font-weight:700}.amount span:first-child{margin-right:0.05333rem;font-size:0.34667rem}\n", ""]);

